import React from 'react'
import { storiesOf } from '@storybook/react'

import Grid from '@material-ui/core/Grid'

import EventDetailsHeader from 'components/EventDetailsHeader'

storiesOf('EventDetailsHeader', module)
  .add('default', () => (
    <Grid direction="column" container>
      <Grid item>
        <EventDetailsHeader />
      </Grid>
      <Grid item>
        <EventDetailsHeader
          color="accent"
        />
      </Grid>
      <Grid item>
        <EventDetailsHeader
          title="manager of the month"
          ribbon={{ text: 'best 5 scores' }}
        />
      </Grid>
      <Grid item>
        <EventDetailsHeader
          title="manager of the month"
          ribbon={{ text: 'best 5 scores' }}
          color="accent"
        />
      </Grid>
      <Grid item>
        <EventDetailsHeader
          title="manager of the month"
          ribbon={{ text: 'best 5 scores', color: 'nile' }}
        />
      </Grid>
    </Grid>
  ))
